import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-layout-options',
  templateUrl: './layout-options.component.html',
  styleUrls: ['./layout-options.component.scss'],
  standalone: false,
})
export class LayoutOptionsComponent {
  @Input() currentLayoutType!: string;
  @Output() selected: EventEmitter<any> = new EventEmitter<any>();

  selectLayoutOption(type: string): void {
    this.selected.emit(type);
  }
}
